import { PropsWithChildren, useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { addFirmHeader } from './api';
import { DOMAIN } from './config';
import { useAuthProfileContext } from './providers/AuthProfileProvider';

type FirmValidatorProps = PropsWithChildren<{}>;
type ProfileFirm = { id: string; shortId: string };

function FirmValidator({ children }: FirmValidatorProps): JSX.Element {
    const profile = useAuthProfileContext();
    const navigate = useNavigate();
    const { firmShortId } = useParams();
    const [loading, setLoading] = useState(true);
    const [firmDetails, setFirmDetails] = useState<ProfileFirm | undefined>();

    useEffect(() => {
        const firms: ProfileFirm[] = profile[`${DOMAIN}/workpapers`].firms || [];
        if (firms.length === 0) {
            navigate('/onboarding');
            return;
        }

        if (firmShortId) {
            const firm = firms.find((f) => f.shortId === firmShortId);
            if (firm) {
                addFirmHeader(firm.id);
                setFirmDetails({ id: firm.id, shortId: firmShortId });
                setLoading(false);
            } else {
                navigate(`/${firms[0].shortId}`, { replace: true });
            }
        } else {
            navigate(`/${firms[0].shortId}`, { replace: true });
        }
    }, [firmShortId, navigate, profile]);

    if (loading) {
        return <></>;
    }

    return <>{children}</>;
}
export default FirmValidator;
